import React from "react";
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Icon,
  Switch,
  Box,
} from "@chakra-ui/react";
import { useHistory, useParams } from "react-router-dom";
import { BiDetail } from "react-icons/bi";
import moment from "moment";
import useFetch from "../../hooks/useFetch";

function PriceListsTable({ priceLists, getPriceLists }) {
  const history = useHistory();
  const { put } = useFetch();

  let params = useParams().state;

  const handleSwitchChange = (id, val) => {
    put(`/priceLists/${id}`, { active: val.target.checked }).then((res) => {
      getPriceLists();
    });
  };

  return (
    <Box overflowX={"scroll"} pb={"0.5rem"}>
      <Table variant="striped" colorScheme="gray" fontSize="0.8em" w="100%">
        <Thead>
          <Tr>
            <Th fontSize="0.8em">Id</Th>
            <Th fontSize="0.8em">Nombre </Th>
            <Th fontSize="0.8em">Descripción</Th>
            <Th fontSize="0.8em">Activo</Th>
            <Th fontSize="0.8em">Última modificación</Th>
            <Th fontSize="0.8em" textAlign="center">
              Detalle
            </Th>
          </Tr>
        </Thead>
        <Tbody>
          {priceLists.map((priceList) => (
            <Tr
              key={priceList.id}
              _hover={{
                outline: "2px #3498DB solid",
              }}
            >
              <Td>{priceList.id}</Td>
              <Td>{priceList.name}</Td>
              <Td>{priceList.description}</Td>
              <Td>
                <Switch
                  isChecked={priceList.active}
                  onChange={(val) => handleSwitchChange(priceList.id, val)}
                />
              </Td>
              <Td>{moment(priceList.modifiedAt).format("DD-MM-YYYY")}</Td>
              <Td textAlign="center">
                <Icon
                  as={BiDetail}
                  _hover={{
                    cursor: "pointer",
                  }}
                  title="Detalle"
                  fontSize="1.5em"
                  onClick={() =>
                    history.push(`/lista-de-precios/${priceList.id}`, {
                      prevPath: params,
                    })
                  }
                />
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </Box>
  );
}

export default PriceListsTable;
